import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const contentStyles = makeStyles(theme => ({
  tabContent: {
    display: "none"
  },
  currentTabContent: {
    display: "block"
  },
}));


const NavigationTabContent = (props) => {

  const classes = contentStyles();

  const { children } = props;

  const [visible, setVisible] = useState(props.visible);

  useEffect(() => {
    setVisible(props.visible)
  }, [props.visible]);

  return (
    <div className = { clsx({
      [classes.tabContent]: true, 
      [classes.currentTabContent]: visible 
      }) }>
      { children }
    </div>
  );
}

NavigationTabContent.propTypes = {
  visible: PropTypes.bool,
  children: PropTypes.node.isRequired
};

NavigationTabContent.defaultProps = {
  visible: false
}

export default NavigationTabContent;